import { Component } from '@angular/core';
import { SupportContentResources } from '../../content/resources/support.content-resources';
import { FetchPriorityEnum } from '../../enums/fetch-priority.enum';
import { LoadingEnum } from '../../enums/loading.enum';
import { BaseComponent } from '../../components/base.component';
import { LocaleManager } from '../../managers/locale.manager';
import { RouteManager } from '../../managers/route.manager';
import { ContentManager } from '../../content/managers/content.manager';
import { Meta, Title } from '@angular/platform-browser';
import { HeaderStyleEnum } from '../../enums/header-style.enum';

@Component({
  selector: 'app-support',
  templateUrl: './support.component.html',
  styleUrl: './support.component.scss',
  standalone: false,
})
export class SupportComponent extends BaseComponent {
  protected readonly SupportContentResources = SupportContentResources;
  protected readonly FetchPriorityEnum = FetchPriorityEnum;
  protected readonly LoadingEnum = LoadingEnum;
  protected readonly HeaderStyleEnum = HeaderStyleEnum;

  constructor(
    localeManager: LocaleManager,
    routeManager: RouteManager,
    contentManager: ContentManager,
    titleService: Title,
    meta: Meta) {
    super(localeManager,
      routeManager,
      contentManager,
      titleService,
      meta,
      SupportContentResources,
    );
  }
}
